import { Injectable } from "@angular/core";

import { RestServiceBase } from "@definitiv-packages/angular-dba-library";

import { UuidModel } from "../../../public-api";

@Injectable({
    providedIn: 'root'
})
export class UuidModelService extends RestServiceBase<UuidModel> {
    constructor() { super("UuidModel"); }

    public createList(list: UuidModel[]): Promise<void> {
        return this.postHttpRequest(this.baseUri + '/create-list', list);
    }
}